module.exports = __webpack_public_path__ + "static/media/mobile_child_usage0.2ff5f4fc.png";